<div
  id="custom-login-form"
  class="min-h-screen bg-cover bg-[url(/assets/images/backgrounds/login_bg.png)] flex justify-center items-center"
>
  <span class="fixed right-2 top-2">
    <app-language-dropdown />
  </span>
  <router-outlet></router-outlet>
</div>
